/** Hosts that serve this app: a pasted link to one of them is a page of the brain, not a website. */
const APP_HOSTS = new Set(['secondbrain.voluro.de', 'dev.secondbrain.voluro.de'])

/**
 * The in-app path of a link to the brain itself (`/n/…`, `/c/…`, `https://secondbrain.voluro.de/n/…`), or null for
 * everything else. API and file URLs stay links (downloads), they are no route.
 */
export function internalPath(
  href: string,
  origin: string = globalThis.location?.origin ?? '',
): string | null {
  let url: URL
  try {
    url = new URL(href, origin || 'https://secondbrain.voluro.de')
  } catch {
    return null
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null
  if (url.origin !== origin && !APP_HOSTS.has(url.hostname)) return null
  if (url.pathname.startsWith('/api/') || url.pathname.startsWith('/collab')) return null
  return `${url.pathname}${url.search}${url.hash}`
}

/** A plain left click without modifiers – ⌘/Ctrl/Shift click keeps the browser's "open in new tab". */
export function plainClick(e: {
  button: number
  metaKey: boolean
  ctrlKey: boolean
  shiftKey: boolean
  altKey: boolean
}) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
}
